export const messages = {
  en: {
    deleteStaffPrivilege: {
      title: 'Confirm Operation',
      deleteMessage: 'Are you sure to delete this privilege?',
      groupDeleteMessage: 'This will delete all privileges in the group, confirm to delete?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Delete successfully',
      mistake: 'Mistake'
    }
  },
  zh: {
    deleteStaffPrivilege: {
      title: '操作确认',
      deleteMessage: '确定删除当前权限吗？',
      groupDeleteMessage: '将删除整个权限组权限，确认删除吗？',
      cancel: '取消',
      confirm: '确定',
      deleteSuccess: '删除成功',
      mistake: '点错了'
    }
  }
}